module.exports = __webpack_public_path__ + "img/minus_btn.aab538a3.png";